import Icon from "@builder/components/general/Icon";
import OliverText from "@builder/components/general/OliverText";
import RenameWrapper from "@builder/components/general/Renamable";
import { deleteLayer, duplicateLayer, setCurrentLayer, setLayerName } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { BaseLayer, BaseLayerTypes } from "@common/build/types";
import { useRef, useState } from "react";
import ContextMenuPages from "../../ContextMenus/ContextMenuPages";
import OliverImage from "../../OliverImage";
import "./style.scss";
import { useTranslation } from "react-i18next";

const SingleLayer = ({ baseLayer, type, index }: { baseLayer: BaseLayer; type: BaseLayerTypes; index: number }) => {
    const currentLayer = useAppSelector(state => state.builder.currentLayer);
    const homepageId = useAppSelector(state => state.builder.build.specialLayers?.homepage?.id);
    const cfdshomepageId = useAppSelector(state => state.builder.build.specialLayers?.customerDisplayHomepage?.id);
    const pages = useAppSelector(state => state.builder.build.pages);
    const isHomepage =
        (type === BaseLayerTypes.PAGES && baseLayer.id === homepageId) || (type === BaseLayerTypes.CFDS && baseLayer.id === cfdshomepageId);
    const isCurrentLayer = currentLayer.type === type && currentLayer.index === index;
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const [isDeleteMode, setIsDeleteMode] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [isInContextMenuMode, setIsInContextMenuMode] = useState(false);

    const singleLayerRef = useRef<HTMLDivElement>(null);

    const renameLayer = (newName: string) => {
        dispatch(setLayerName({ type, index, name: newName }));
    };

    return (
        <>
            <div
                className={`single-layer ${isDeleteMode ? "delete-mode" : isCurrentLayer && !isEditing ? "current-layer" : ""} ${
                    isInContextMenuMode ? "with-context-menu" : ""
                } ${isEditing ? "edit-mode" : ""}`}
                ref={singleLayerRef}
            >
                <div className="icons">{isHomepage && <OliverImage src={"./home-icon.svg"} />}</div>
                {isDeleteMode ? (
                    <span className="layer-name">
                        <OliverText text={`${t("sidebarCollapse.Delete")} ${baseLayer.name}?`} size="xs" />
                    </span>
                ) : (
                    <span
                        className="layer-name"
                        onClick={() => {
                            dispatch(setCurrentLayer({ type, index }));
                        }}
                    >
                        <RenameWrapper text={baseLayer.name} onRename={renameLayer} textProps={{ size: "xs" }} setIsEditingState={setIsEditing} />
                    </span>
                )}
                <div className="action-buttons" style={isDeleteMode ? { opacity: 1 } : {}}>
                    {isDeleteMode ? (
                        <>
                            <div className="copy" onClick={() => setIsDeleteMode(false)}>
                                <Icon src="/cross.svg" />
                            </div>
                            <div className="delete" onClick={() => dispatch(deleteLayer({ type, index }))}>
                                <Icon src="/check.svg" />
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                className="copy"
                                onClick={() => {
                                    dispatch(duplicateLayer({ type, index }));
                                }}
                            >
                                <Icon src="./copy-icon-blue.svg" />
                            </div>
                            {(type !== BaseLayerTypes.PAGES || pages.length > 1) && (
                                <div className="delete" onClick={() => setIsDeleteMode(true)}>
                                    <Icon src="./trash.svg" />
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            {((type === BaseLayerTypes.PAGES && !isHomepage) || (type === BaseLayerTypes.CFDS && !isHomepage)) && (
                <ContextMenuPages targetRef={singleLayerRef} pageID={baseLayer.id} stateSelectedElement={setIsInContextMenuMode} type={type} />
            )}
        </>
    );
};

export default SingleLayer;
